import {LeftOutlined} from '@ant-design/icons';
import {Button, Chip} from '@ds/components';

import {
  PRODUCT_SCORE_TREND_TEXT,
  SCORE_LABELS,
  SCORE_TITLES
} from '../../constants';
import type {ProductScoreTrendData, ScoreType} from '../../types';

type ProductScoreTrendsProps = {
  data: ProductScoreTrendData[];
  onActionClick: (type: ScoreType) => void;
};

const ProductScoreTrends: React.FC<ProductScoreTrendsProps> = ({data, onActionClick}) => {
  return (
    <section className="flex flex-col gap-5 px-4 py-4">
      <h2 className="text-body-md-emphasis text-gray-09">محصولات و موجودی</h2>
      <div className="flex flex-col gap-2.5">
        {data.map((item, index) => {
          const {score_type: scoreType, score_label: scoreLabel} = item;
          if (!scoreType) return null;

          const isGood = scoreLabel === 'VERY_GOOD' || scoreLabel === 'GOOD';
          const needsAction = scoreLabel === 'WEAK' || scoreLabel === 'VERY_WEAK';

          return (
            <article
              key={`${scoreType}-${index}`}
              className="flex flex-col gap-2.5 rounded-lg bg-gray-02 p-4"
            >
              <header className="flex items-center justify-between gap-3">
                <h3 className="text-body-sm-emphasis text-gray-09">{SCORE_TITLES[scoreType]}</h3>
                <Chip
                  label={scoreLabel ? SCORE_LABELS[scoreLabel] : 'نامشخص'}
                  variant="soft"
                  color={isGood ? 'success' : 'error'}
                />
              </header>
              {scoreLabel && (
                <p className="text-body-sm text-gray-08">
                  {PRODUCT_SCORE_TREND_TEXT[scoreType][scoreLabel]}
                </p>
              )}
              {needsAction && (
                <Button
                  className="self-start px-0"
                  variant="link"
                  size="sm"
                  onClick={() => onActionClick(scoreType)}
                >
                  <span className="underline">مشاهده لیست کالاها</span>
                  <LeftOutlined aria-hidden />
                </Button>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default ProductScoreTrends;
